import { PopupsActionTypes, Popups } from 'ui/types/popups';

export const openPopup = <TData = any>(id: Popups, data?: TData) => ({
  type: PopupsActionTypes.OPEN_POPUP as const,
  payload: { id, data }
});

export const closePopup = (id: Popups) => ({
  type: PopupsActionTypes.CLOSE_POPUP as const,
  payload: { id }
});


